import { render, staticRenderFns } from "./OrderSubmitSuccess.vue?vue&type=template&id=674aa5fa&scoped=true"
import script from "./OrderSubmitSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSubmitSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderSubmitSuccess.vue?vue&type=style&index=0&id=674aa5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aa5fa",
  null
  
)

export default component.exports